import React, { useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import { getCollectionList } from '../../../actions/kafairAction';
import { getRecommendedProduct } from '../../../actions/productAction';
import { connect } from 'react-redux';
import ProductSlider from './Helpers/ProductSlider';

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

type ForYou = {
  history: History;
  category: string;
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => any;
  dataFlashSale: Array<Object>;
  getRecommendedProduct: (userId: number, category: string) => any;
  userId: number;
  isLogged: boolean;
  recommendedProducts: Array<ForYouProducts>;
};
interface ForYouProducts {
  category: string;
}

const ForYou: FC<ForYou> = ({
  history,
  category,
  recommendedProducts,
  getRecommendedProduct,
  userId,
  isLogged,
}) => {
  useEffect(() => {
    // Fetch recommended products
    let categoryProduct =
      category === 'apparels' || category === 'Apparels'
        ? 'apparels'
        : category === 'lifestyles'
        ? 'electronics-collectibles'
        : category;
    if (userId) {
      getRecommendedProduct(userId, categoryProduct);
    }
  }, [userId]);

  function navigate(url: string) {
    // navigate onClick products
    history.push(url);
  }

  // Don't display if user is not logged in
  if (!isLogged) return null;

  // View on mobile screen and products length is available
  if (
    window.screen.availWidth < 480 &&
    recommendedProducts &&
    recommendedProducts.length > 0
  ) {
    let categoryUrl =
      category === 'apparels' || category === 'Apparels'
        ? 'apparel'
        : category === 'handbags'
        ? 'luxury'
        : category === 'lifestyles'
        ? 'electronics-collectibles'
        : category;

    let categoryProduct =
      category === 'apparels' || category === 'Apparels'
        ? 'apparels'
        : category === 'lifestyles'
        ? 'electronics-collectibles'
        : category;

    if (
      recommendedProducts.filter((item) => item.category === categoryProduct)
        .length <= 0
    )
      return null;

    return (
      <div style={{ marginBottom: '0px' }} className="ForYou">
        <div className="ForYou__Header">
          <div className="ForYou__Title">
            <p style={{ marginBottom: '0px' }}>For You</p>
          </div>
        </div>
        <div style={{ marginTop: '0px' }} className="KickFairV3-Main">
          {recommendedProducts.length > 0 && (
            <ProductSlider
              dataProducts={recommendedProducts.filter(
                (item) => item.category === categoryProduct,
              )}
              navigate={navigate}
              isRecommendedProduct
              navigateUrl={`/${categoryUrl}/for-you`}
              activeBrowseAll
              chosenOption={'For You'}
            />
          )}
        </div>
      </div>
    );
  }

  // Display on desktop screen and products is available
  if (recommendedProducts && recommendedProducts.length > 0) {
    let categoryUrl =
      category === 'apparels' || category === 'Apparels'
        ? 'apparel'
        : category === 'handbags'
        ? 'luxury'
        : category === 'lifestyles'
        ? 'electronics-collectibles'
        : category;

    let categoryProduct =
      category === 'apparels' || category === 'Apparels'
        ? 'apparels'
        : category === 'lifestyles'
        ? 'electronics-collectibles'
        : category;

    // Filter available item category based on current category
    if (
      recommendedProducts.filter((item) => item.category === categoryProduct)
        .length <= 0
    )
      return null;

    return (
      <div
        style={{ paddingTop: '0px', paddingBottom: '0px' }}
        className="KickFair-v3"
      >
        <div className="KickFairV3-Header">
          <div className="KickFairV3-Title">
            <p style={{ fontSize: '24px' }}>For You</p>
          </div>
          <div className="KickFairV3-Ticket">
            {/* <p onClick={() => navigate(`/${category}/collection/for-you`)}>View All</p> */}
          </div>
        </div>
        <div style={{ marginTop: '15px' }} className="KickFairV3-Main">
          {recommendedProducts.length > 0 && (
            <ProductSlider
              dataProducts={recommendedProducts.filter(
                (item) => item.category === categoryProduct,
              )}
              isRecommendedProduct
              activeBrowseAll
              chosenOption={'For You'}
              navigate={navigate}
              navigateUrl={`/${categoryUrl}/for-you`}
            />
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

interface Data {
  data: Array<Object>;
}
interface FlashSale {
  flashSale: Data;
}
interface DataKaFair {
  dataKaFair: FlashSale;
}

const mapStateToProps = (state: DataKaFair) => ({
  recommendedProducts: state.dataProduct.dataRecommended.data,
  userId: state.dataAuth.userdata.id,
  isLogged: state.dataAuth.isLogged,
});

const mapDispatchToProps = (dispatch: any) => ({
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => dispatch(getCollectionList(category, slug, payload, name)),
  getRecommendedProduct: (userId, category) =>
    dispatch(getRecommendedProduct(userId, category, '', true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForYou);
